// The drawer slides in over 300ms and out over 200ms, matching `.focus-drawer-*` (transitions.scss).
const FOCUS_DRAWER_DURATION = { enter: 300, leave: 200 } as const

export { FOCUS_DRAWER_DURATION }
